module.exports = ['$scope', ($scope) ->
  @default = @default || "Save Changes"
  @inProcess = @inProcess || "Saving..."
  @done = @done || "Saved"
  @buttonState = 'default'

  $scope.$watch 'ctrl.error', (error) =>
    if error.length > 0
      @form.$setPristine()
      @form.$setDirty()
      @buttonState = 'default'

  $scope.$watch 'ctrl.form.$dirty', (dirty) =>
    @buttonState = 'default' if dirty is true

  $scope.$watch 'ctrl.form.$submitted', (submitted) =>
    @buttonState = 'done' if @buttonState is 'inProcess'
    @buttonState = 'inProcess' if submitted is true and @buttonState is 'default'
    @buttonState = 'default' if @buttonState is 'done'
  @
]
